/* Copyright 2019 VMware, Inc. All rights reserved. -- VMware Confidential */

namespace h5_vm {
   export class VmProvisioningNetworkPageUtilService {
      public static $inject: string[] = [
            "$q",
            "defaultUriSchemeUtil",
            "dataService",
      ];

      constructor(
            private $q: any,
            private defaultUriSchemeUtil: any,
            private dataService: any
      ) {
      }

      /**
       * @return The network provider id - that is the object
       *    who will be queried for available/accessible networks when needed.
       */
      public getOrRequestNetworkProviderId(
            model: { getWorkflowContextObject: () => any }
      ): angular.IPromise<string> {
         const contextObject = model.getWorkflowContextObject();
         const contextObjectType = contextObject && contextObject.type;

         switch (contextObjectType) {
            case "HostSystem":
            case "ClusterComputeResource":
            case "ComputeResource":
               // We already have what we need - no remote calls
               return this.$q.resolve(this.defaultUriSchemeUtil.getVsphereObjectId(contextObject));
            default:
               // If here, then contextObjectType should be ResourcePool or VirtualApp.
               const contextObjectId = this.defaultUriSchemeUtil.getVsphereObjectId(contextObject);
               return this.dataService.getProperties(contextObjectId, ["owner", "host"], {
                  queryName: "getOrRequestNetworkProviderId"
               }).then((result: {host?: string, owner?: string}) => {
                  return result.host ?
                        this.defaultUriSchemeUtil.getVsphereObjectId(result.host) :
                        this.defaultUriSchemeUtil.getVsphereObjectId(result.owner);
               });
         }
      }
   }

   angular.module("com.vmware.vsphere.client.vm")
         .service("vmProvisioningNetworkPageUtilService", VmProvisioningNetworkPageUtilService);
}
